import { Collapse, Slider } from "@mui/material";
import React, { Fragment } from "react";
import { FiChevronDown, FiChevronUp } from "react-icons/fi";
import styles from "./filter_box_slider.module.scss";

// type (collapsible, normal)

export const FilterBoxSlider = ({
  title,
  range,
  value,
  onChange,
  loading,
  icon = false,
  offset = false,
  type = "collapsible",
  ...props
}) => {
  const [open, setOpen] = React.useState(true);
  const [valueState, setValue] = React.useState(value);

  const handleClick = () => {
    setOpen(!open);
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const changeCommitted = (event, newValue) => {
    if (onChange) {
      onChange(newValue);
    }
  };

  return (
    <Fragment>
      {type == "collapsible" && (
        <div className={styles.filter_option}>
          <div onClick={handleClick} className={styles.option_title_wrapper}>
            <span className={styles.option_title}>{title || ""}</span>
            <span className={styles.icon}>
              {open ? <FiChevronUp /> : <FiChevronDown />}
            </span>
          </div>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <div className={styles.filter_slider_wrapper}>
              <div className={styles.slider_range_text}>
                <span className={styles.currncy}>
                  {offset && offset == "left" && icon && icon}
                  {valueState && valueState[0]}{" "}
                  {offset && offset == "right" && icon && icon}
                </span>
                <span className={styles.currncy}>
                  {offset && offset == "left" && icon && icon}
                  {valueState && valueState[1]}{" "}
                  {offset && offset == "right" && icon && icon}
                </span>
              </div>
              <Slider
                value={valueState}
                onChange={handleChange}
                onChangeCommitted={changeCommitted}
                valueLabelDisplay="off"
                min={range[0] ?? 0}
                max={range[1] ?? 1}
                className={styles.slideContainer}
                disabled={loading}
              />
            </div>
          </Collapse>
        </div>
      )}
      {type == "normal" && (
        <div className={styles.filter_slider_wrapper}>
          <div className={styles.slider_range_text}>
            <span className={styles.currncy}>
              {offset && offset == "left" && icon && icon}
              {valueState && valueState[0]}{" "}
              {offset && offset == "right" && icon && icon}
            </span>
            <span className={styles.currncy}>
              {offset && offset == "left" && icon && icon}
              {valueState && valueState[1]}{" "}
              {offset && offset == "right" && icon && icon}
            </span>
          </div>
          <Slider
            value={valueState}
            onChange={handleChange}
            onChangeCommitted={changeCommitted}
            valueLabelDisplay="off"
            min={range[0] ?? 0}
            max={range[1] ?? 1}
            className={styles.slideContainer}
            disabled={loading}
          />
        </div>
      )}
    </Fragment>
  );
};

export default FilterBoxSlider;
